// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".multiselect-categories[data-v-9cfdc470]{--ms-max-height:40rem}", "",{"version":3,"sources":["webpack://./resources/js/Components/Forms/CategorySelect.vue"],"names":[],"mappings":"AACA,yCACE,qBAAF","sourcesContent":["\n.multiselect-categories {\n  --ms-max-height: 40rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
